"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlockConsolidationMigration = void 0;
var BlockTypes_1 = require("@CommonFrontendBackend/BlockModels/BlockTypes");
var axios_1 = __importDefault(require("axios"));
var MappingOldToNew_1 = require("@CommonFrontendBackend/BlockConsolidation/MappingOldToNew");
var lodash_1 = require("lodash");
var Utils_1 = require("@CommonFrontendBackend/BlockConsolidation/Utils");
var Sentry = __importStar(require("@sentry/browser"));
var DefaultStyles_1 = __importDefault(require("@CommonFrontendBackend/StyleService/DefaultStyles"));
var v0FactoryStyles = require("@CommonFrontendBackend/StyleServiceV2/TCDCConverter/V0FactoryStyle.js");
var BlockConsolidationMigration = (function () {
    function BlockConsolidationMigration(brandStore, account, apiBaseUrl, environment) {
        var _this = this;
        this.brandStore = brandStore;
        this.account = account;
        this.apiBaseUrl = apiBaseUrl;
        this.environment = environment;
        this.ignoredFields = {};
        this.log = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (_this.DEBUG) {
                console.log.apply(console, __spreadArray(["[BlockConsolidationMigration]"], __read(args), false));
            }
        };
        this.bulkMigrateBlocks = function (blocks, migrationType) { return __awaiter(_this, void 0, Promise, function () {
            var blocksToSave, blocks_1, blocks_1_1, block, mappedBlockData, successfulBlocks, response, error_1, data, errorMessage;
            var e_1, _a;
            var _this = this;
            var _b, _c, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        blocksToSave = [];
                        this.log("Starting block migration");
                        try {
                            for (blocks_1 = __values(blocks), blocks_1_1 = blocks_1.next(); !blocks_1_1.done; blocks_1_1 = blocks_1.next()) {
                                block = blocks_1_1.value;
                                if (this.shouldMigrate(block)) {
                                    try {
                                        this.preMigration(block);
                                        mappedBlockData = this.runMapping(block);
                                        blocksToSave.push(mappedBlockData);
                                    }
                                    catch (error) {
                                        console.error("Error while migrating ".concat(block.type, " block ").concat(block._id, ". Skipping block."), error);
                                        Sentry.captureException(new Error("Error while migrating ".concat(block.type, " block ").concat(block._id)), {
                                            tags: { blockConsolidationMigration: "yes" },
                                            extra: {
                                                schema: "Legacy ".concat(block.type, " Block Schema"),
                                                handler: "BlockConsolidationMigration.ts",
                                                ctx: {
                                                    blockId: block._id,
                                                    blockType: block.type,
                                                },
                                                zodIssues: error === null || error === void 0 ? void 0 : error.issues,
                                            },
                                        });
                                    }
                                }
                            }
                        }
                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                        finally {
                            try {
                                if (blocks_1_1 && !blocks_1_1.done && (_a = blocks_1.return)) _a.call(blocks_1);
                            }
                            finally { if (e_1) throw e_1.error; }
                        }
                        successfulBlocks = [];
                        if (!(blocksToSave.length > 0)) return [3, 4];
                        _e.label = 1;
                    case 1:
                        _e.trys.push([1, 3, , 4]);
                        return [4, this.saveMigratedBlocks(blocksToSave, migrationType)];
                    case 2:
                        response = _e.sent();
                        (_b = response.data.blocks) === null || _b === void 0 ? void 0 : _b.forEach(function (blockId) {
                            var blockData = blocksToSave.find(function (backedUpBlock) { return backedUpBlock._id === blockId; });
                            if (blockData) {
                                successfulBlocks.push(_this.postMigration(blockData));
                            }
                        });
                        return [3, 4];
                    case 3:
                        error_1 = _e.sent();
                        if (axios_1.default.isAxiosError(error_1)) {
                            data = (_c = error_1.response) === null || _c === void 0 ? void 0 : _c.data;
                            errorMessage = (_d = data === null || data === void 0 ? void 0 : data.message) !== null && _d !== void 0 ? _d : "An unknown error occurred while saving the migrated blocks";
                            console.error("Error while saving migrated blocks. Skipping migration.", errorMessage);
                        }
                        return [3, 4];
                    case 4:
                        this.log("Finished block migration");
                        return [2, successfulBlocks];
                }
            });
        }); };
        this.shouldMigrate = function (block) {
            var alreadyMigrated = block.type === BlockTypes_1.BlockType.Text && block.isMigrated;
            if (Utils_1.blockTypesToMigrate.includes(block.type) && !alreadyMigrated) {
                _this.log("Migrating ".concat(block.type, " block to Text block"));
                return true;
            }
            _this.log("Skipping ".concat(block.type, " block. Reason: ").concat(alreadyMigrated ? "already migrated" : "excluded block type"));
            return false;
        };
        this.preMigration = function (block) {
            var fieldsToIgnore = Object.keys(block).filter(function (key) { return key.startsWith("$"); });
            var blockData = (0, lodash_1.pick)(block, fieldsToIgnore);
            _this.ignoredFields[block._id] = blockData;
            fieldsToIgnore.forEach(function (field) { return (0, lodash_1.unset)(block, field); });
            return block;
        };
        this.runMapping = function (rawBlock) {
            var schema = (0, MappingOldToNew_1.getSchemaForBlockType)(rawBlock.type);
            var brandColors = _this.brandStore.allColorsWithThemeIndex;
            var accountId = _this.account._id;
            var block = schema.parse(rawBlock);
            var migratedBlock = (0, MappingOldToNew_1.migrateBlock)(block, accountId, brandColors, __spreadArray(__spreadArray(__spreadArray([], __read(_this.account.styles), false), __read(DefaultStyles_1.default), false), __read(v0FactoryStyles), false));
            return migratedBlock;
        };
        this.postMigration = function (block) {
            var ignoredFieldsForBlock = _this.ignoredFields[block._id];
            if (!(0, lodash_1.isEmpty)(ignoredFieldsForBlock)) {
                return Object.assign(block, ignoredFieldsForBlock);
            }
            return block;
        };
        this.saveMigratedBlocks = function (blocks, migrationType) {
            if (migrationType === Utils_1.MigrationType.SavedBlock) {
                return axios_1.default.post("".concat(_this.apiBaseUrl, "/accounts/").concat(_this.account._id, "/migrate-saved-block"), { blocks: blocks }, {
                    withCredentials: true,
                });
            }
            else {
                return axios_1.default.post("".concat(_this.apiBaseUrl, "/accounts/").concat(_this.account._id, "/migrate-blocks"), { blocks: blocks }, {
                    withCredentials: true,
                });
            }
        };
        this.DEBUG = this.environment !== "production" ? true : false;
    }
    return BlockConsolidationMigration;
}());
exports.BlockConsolidationMigration = BlockConsolidationMigration;
